import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../../../../../utils/Context';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getRequest } from '../../../../../../api/api';
import { GET_PD_PREMIUM } from '../../../../../../api/endpoint';
import { ToastManager } from '../../../../../../ToastContainer/ToastContainer';
import { formatInput } from '../../../../../../utils/Commonutils';
import Button from 'react-bootstrap/Button';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import ScrollToTopLink from '../../../../../ScrollToTop/ScrollToTop';
import { Spinner } from 'react-bootstrap';
import { ImCross } from 'react-icons/im';

const PhysicalDamage = ({
  handleTabChange,
  PDPolicyDetailsListing,
  getSubscriptionFor,
  saveProfile,
  PDpolicyListingRepsonse,
  openFirstAccordion,
  isDirectCheckout,
}) => {
  const [TrailerInterchange, setTrailerInterchange] = useState('No');
  const [pdPremium, setPDPremium] = useState(null);
  const { profileObject, setDirectCheckout } = useContext(Context);
  const [numberOfTrailers, setNumberOfTrailers] = useState(null);
  const [trailerValue, setTrailerValue] = useState(null);
  const [selectedGaragingState, setSelectedGaragingState] = useState(null);
  const [StateOption, setStateOption] = useState([]);
  const [pdSubObj, setpdSubObj] = useState({});
  const [availibilityMsg, setAvailibilityMsg] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formattedTrailerValue, setFormattedTrailerValue] = useState('');
  const [params, setParams] = useState({
    pd_deductible: 1000,
    towing_and_clean_up_limit: 5000,
  });
  const [isCoverageDeclined, setIsCoverageDeclined] = useState(false);

  useEffect(() => {
    setpdSubObj(getSubscriptionFor('PD'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileObject]);

  useEffect(() => {
    if (pdSubObj && Object.keys(pdSubObj).length !== 0) {
      const garagingState = {
        ...pdSubObj?.primary_garaging_state,
        label: pdSubObj?.primary_garaging_state?.name,
      };
      setSelectedGaragingState(garagingState);
      setParams({
        pd_deductible: parseInt(pdSubObj?.pd_deductible),
        towing_and_clean_up_limit: parseInt(
          pdSubObj?.towing_and_clean_up_limit
        ),
        primary_garaging_state: pdSubObj?.primary_garaging_state,
        primary_garaging_state_id: pdSubObj?.primary_garaging_state_id,
        number_of_trailers: pdSubObj?.number_of_trailers,
        trailer_interchange: pdSubObj?.trailer_interchange,
        trailer_max_value: pdSubObj?.trailer_max_value,
      });
      let TrailerInterchangeValue =
        pdSubObj.trailer_interchange === false ? 'No' : 'Yes';
      setTrailerInterchange(TrailerInterchangeValue);
      setNumberOfTrailers(pdSubObj?.number_of_trailers);
      setFormattedTrailerValue(
        formatInputTrailerValue(
          pdSubObj?.trailer_max_value && pdSubObj?.trailer_max_value.toString()
        )
      );
      setTrailerValue(pdSubObj?.trailer_max_value);
      setPDPremium({
        calculated_premium: pdSubObj?.calculated_total,
      });
      setIsCoverageDeclined(false);
    } else {
      setIsCoverageDeclined(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdSubObj]);

  const deductibleOption = [
    {
      label: '$1,000',
      value: 1000,
      id: '$1,000',
      type: 'radio',
    },
    {
      label: '$2,500',
      value: 2500,
      id: '$2,500',
      type: 'radio',
    },
  ];

  const towingOption = [
    {
      label: '$5,000',
      value: 5000,
      id: '$5,000',
      type: 'radio',
    },
    {
      label: '$10,000',
      value: 10000,
      id: '$10,000',
      type: 'radio',
    },
  ];

  const pdPolicy = [
    {
      label: 'Physical Damage',
      id: 'physicalDamage',
      type: 'radio',
      name: 'policy',
      value: 'physicalDamage',
      planName: 'Physical Damage',
      planCost: '$300,000',
      monthlyCost: '$25,00',
    },
  ];

  const handleNumberOfTrailers = (event) => {
    const numberOfTrailersValue = parseInt(event.target.value, 10);
    const trailersNumber = {
      ...params,
      number_of_trailers: numberOfTrailersValue,
      trailer_interchange: true,
    };
    setParams(trailersNumber);
    GaragingState(trailersNumber);
    setNumberOfTrailers(numberOfTrailersValue);
  };

  const handleTrailerValue = (event) => {
    const inputValue = event.target.value;
    const trailerMaxValue = {
      ...params,
      trailer_max_value: parseFloat(inputValue.replace(/[^0-9.]/g, '')),
    };
    GaragingState(trailerMaxValue);
    setParams(trailerMaxValue);
    setFormattedTrailerValue(formatInputTrailerValue(inputValue));
    setTrailerValue(parseFloat(inputValue.replace(/[^0-9.]/g, '')));
  };

  const formatInputTrailerValue = (value) => {
    const numericValue = parseFloat(value && value.replace(/[^0-9.]/g, ''));

    if (!isNaN(numericValue)) {
      return new Intl.NumberFormat('en-US').format(numericValue);
    } else {
      return '';
    }
  };

  const handleDeductibleChange = (deductible) => {
    const deductibleParams = {
      ...params,
      pd_deductible: deductible,
    };
    setParams(deductibleParams);
    GaragingState(deductibleParams);
  };

  const handleTowingChange = (towing) => {
    const towingParams = {
      ...params,
      towing_and_clean_up_limit: towing,
    };
    setParams(towingParams);
    GaragingState(towingParams);
  };

  const handleTrailerChange = (selectedPolicy) => {
    setTrailerInterchange(selectedPolicy);
    if (selectedPolicy === 'No') {
      setNumberOfTrailers(null);
      const trailerMaxValue = {
        ...params,
        trailer_max_value: '',
      };
      GaragingState(trailerMaxValue);
      setParams(trailerMaxValue);
      setTrailerValue(null);
      setFormattedTrailerValue('');
    }
  };

  const GaragingState = async (params) => {
    try {
      const response = await getRequest(GET_PD_PREMIUM, params);
      const stateData = response.result;
      const mappedOptions = stateData.states.map((item) => ({
        value: item.name,
        label: item.name,
        id: item.id,
      }));
      setPDPremium(response.result);
      setAvailibilityMsg(response.result.message);
      setStateOption(mappedOptions);
    } catch (error) {
      console.log('err', error);
    }
  };

  const handleGaragingStateChange = (state) => {
    const stateParams = {
      ...params,
      primary_garaging_state: JSON.stringify(state),
      primary_garaging_state_id: state?.id || null,
    };
    setParams(stateParams);
    setSelectedGaragingState(state);
    GaragingState(stateParams);
  };

  useEffect(() => {
    GaragingState(params); // Fetch state data when the component mounts
  }, [params]);

  const handlePDSave = (isCheckout = false) => {
    setButtonLoading(true);
    if (isCoverageDeclined) {
      handleDecline();
      setButtonLoading(false);
      return false;
    }

    if (selectedGaragingState === null) {
      ToastManager.error('Please select Primary Garaging State');
      setButtonLoading(false);
      return false;
    }

    const trailer_interchange = TrailerInterchange === 'No' ? false : true;
    if (trailer_interchange) {
      if (
        numberOfTrailers === 0 ||
        isNaN(numberOfTrailers) ||
        numberOfTrailers === null
      ) {
        ToastManager.error('Please select Number of Trailers');
        setButtonLoading(false);
        return false;
      }
      if (trailerValue === 0 || isNaN(trailerValue) || trailerValue === null) {
        ToastManager.error('Please enter Trailer Value');
        setButtonLoading(false);
        return false;
      }
    } else {
      setNumberOfTrailers(null);
      setTrailerValue(null);
    }

    const pdSubscription = getSubscriptionFor('PD');
    let { primary_garaging_state } = params;
    if (primary_garaging_state && typeof primary_garaging_state === 'string') {
      primary_garaging_state = JSON.parse(primary_garaging_state);
    }
    const data = {
      programs_attributes: [
        {
          id: profileObject?.programs[0]?.id,
          subscriptions_attributes: [
            {
              ...params,
              primary_garaging_state,
              id: pdSubscription.id,
              subject_id: profileObject?.programs[0]?.id,
              subject_type: 'Program',
              subscribable_id:
                PDpolicyListingRepsonse && PDpolicyListingRepsonse[0]?.id,
              subscribable_type: 'PolicyDetail',
              trailer_interchange: trailer_interchange,
              number_of_trailers: numberOfTrailers,
              trailer_max_value: trailerValue,
              type: 'YearlySubscription',
            },
          ],
        },
      ],
      vehicle_details_attributes: [{}],
    };
    saveProfile(data).then((success) => {
      if (success) {
        PDPolicyDetailsListing();
        if (isCheckout) {
          setDirectCheckout(true);
          isDirectCheckout('PD');
        } else {
          setDirectCheckout(false);
          handleTabChange('cargo');
        }
      }
      setButtonLoading(false);
    });
  };

  const handleBack = () => {
    openFirstAccordion();
    handleTabChange('passengerAccident');
  };

  const handleDecline = () => {
    const pdSubscription = getSubscriptionFor('PD');
    const data = {
      programs_attributes: [
        {
          id: profileObject?.programs[0]?.id,
          subscriptions_attributes: [
            {
              id: pdSubscription.id,
              _destroy: true,
            },
          ],
        },
      ],
      vehicle_details_attributes: [{}],
    };
    setIsCoverageDeclined(true);
    saveProfile(data).then((success) => {
      if (success) {
        handleTabChange('cargo');
      }
      setButtonLoading(false);
    });
    return false;
  };

  const preventMinus = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="container my-md-5 mt-20-sm-imp mb-0 mt-3 plr-0-sm">
        <Form className="text-start">
          <div>
            <Form.Group className="user-detail-form-blue mb-3">
              <Form.Label className="font-16-sm fw-bold mb-2 ">
                Primary Garaging State
              </Form.Label>
              <Select
                className="custom-select"
                options={StateOption}
                isClearable
                value={selectedGaragingState}
                onChange={(selectedOption) =>
                  handleGaragingStateChange(selectedOption)
                }
                placeholder="Select Primary Garaging State"
              />
            </Form.Group>
          </div>

          <div className="row my-md-5 my-4">
            <div className="col-md-6">
              <Form.Label className="font-16-sm fw-bold mb-2">
                Deductible (Each & Every Loss / Each & Every Unit)
              </Form.Label>
              <Row>
                {deductibleOption.map((option) => (
                  <Col md={3} key={option.value}>
                    <Form.Group key={option.value}>
                      <Form.Check
                        className="radio-label"
                        type={option.type}
                        label={option.label}
                        name={option.name}
                        value={option.value}
                        checked={params?.pd_deductible === option.value}
                        onChange={() => handleDeductibleChange(option.value)}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </div>
            <div className="col-md-6">
              <Form.Label className="font-16-sm fw-bold mb-2 mt-md-0 mt-3">
                Towing Options (Additional to ACV)
              </Form.Label>
              <Row>
                {towingOption.map((option) => (
                  <Col md={3} key={option.value}>
                    <Form.Group key={option.value}>
                      <Form.Check
                        className="radio-label"
                        type={option.type}
                        label={option.label}
                        name={option.name}
                        value={option.value}
                        checked={
                          params?.towing_and_clean_up_limit === option.value
                        }
                        onChange={() => handleTowingChange(option.value)}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </div>
          </div>

          <hr />
          <Form.Label className="font-16-sm fw-bold mt-2 mt-md-4 mb-2 ">
            Trailer Interchange
          </Form.Label>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Check
                  className="radio-label"
                  type="radio"
                  label="Yes"
                  name="PDTowingPolicy"
                  value="Yes"
                  checked={TrailerInterchange === 'Yes'}
                  onChange={() => handleTrailerChange('Yes')}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Check
                  className="radio-label"
                  type="radio"
                  label="No"
                  name="PDTowingPolicy"
                  value="No"
                  checked={TrailerInterchange === 'No'}
                  onChange={() => handleTrailerChange('No')}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>
          {TrailerInterchange === 'Yes' && (
            <div className="mt-3">
              {/* Input fields for "Yes" */}
              <Form.Group className="user-detail-form-blue mb-0 mb-md-3">
                <Form.Label className="font-16-sm fw-bold">
                  Number Of Trailers :
                </Form.Label>
                <Form.Control
                  className="radio-label"
                  type="number"
                  onChange={handleNumberOfTrailers}
                  value={numberOfTrailers || ''}
                  placeholder="Enter Number Of Trailers"
                  min="0"
                  onKeyPress={preventMinus}
                />
              </Form.Group>
              <Form.Group className="user-detail-form-blue mb-3">
                <Form.Label className="font-16-sm fw-bold">
                  Maximum Value (USD) :
                </Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleTrailerValue}
                  value={formattedTrailerValue || ''}
                  placeholder="Enter Maximum Value"
                  min="0"
                  onKeyPress={preventMinus}
                />
              </Form.Group>
            </div>
          )}
          <Row className="mt-md-5 mt-4 pricing-plan">
            {pdPolicy.map((field, index) => (
              <React.Fragment key={index}>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <div>
                      <div className="">
                        <div className="box cursor-pointer">
                          <div
                            className={`card ${
                              isCoverageDeclined ? '' : 'selected'
                            }`}
                            controlId={field.id}
                            onClick={() => setIsCoverageDeclined(false)}
                          >
                            <div className="d-flex justify-content-end">
                              <Form.Check
                                type={field.type}
                                name={field.plan_type?.name}
                                value={field.plan_type?.code_name || ''}
                                checked={!isCoverageDeclined}
                                readOnly
                              />
                            </div>
                            <span className="plan-details text-center">
                              <span className="plan-type">
                                {field.planName}
                              </span>
                            </span>
                            {/*<hr />*/}
                            <span className="d-flex justify-content-between mt-4">
                              <span className="text-black m-0 m-md-2 fs-5 font-16-sm">
                                Physical Damage{' '}
                              </span>
                              <span className="text-muted fw-bold text-center fs-5 p-0 pt-md-2 font-16-sm">
                                $
                                {formatInput(pdPremium?.pd_premium?.toFixed(2))}
                              </span>
                            </span>
                            <hr />
                            {TrailerInterchange === 'Yes' && (
                              <Form.Group className="mb-0 mb-md-3">
                                <div>
                                  <span className="plan-details">
                                    <span className="d-flex justify-content-between">
                                      <span className="text-black m-0 m-md-2 fs-5 font-16-sm">
                                        Trailer Interchange{' '}
                                      </span>
                                      <span className="text-muted fw-bold text-center fs-5 p-0 pt-md-2 font-16-sm">
                                        $
                                        {formatInput(
                                          pdPremium?.trailer_premium
                                        )}
                                      </span>
                                    </span>
                                  </span>
                                </div>
                                <hr />
                              </Form.Group>
                            )}
                            <div className="d-flex justify-content-between">
                              <span className="text-black m-0 m-md-2 fs-5 font-16-sm">
                                Total{' '}
                              </span>
                              <span className="text-muted fw-bold text-center fs-5 pt-2">
                                $
                                <span>
                                  {formatInput(
                                    pdPremium?.calculated_premium?.toFixed(2)
                                  )}
                                  /yr
                                </span>
                              </span>
                            </div>
                            <span className="text-muted fw-bold text-end fs-6 pt-2">
                              {pdPremium?.monthly_premium && '$'}
                              {pdPremium?.monthly_premium ? (
                                <span>
                                  {formatInput(
                                    pdPremium?.monthly_premium?.toFixed(2)
                                  )}
                                  /mo
                                </span>
                              ) : (
                                ''
                              )}
                            </span>
                            <span className="text-muted fw-bold text-end fs-6 pt-2">
                              {pdPremium?.weekly_premium && '$'}
                              {pdPremium?.weekly_premium ? (
                                <>
                                  {formatInput(
                                    pdPremium?.weekly_premium?.toFixed(2)
                                  )}
                                  <span className="slash">/</span>
                                  <span className="" title="week">
                                    wk
                                  </span>
                                </>
                              ) : (
                                ''
                              )}
                            </span>
                            <span
                              type="submit"
                              className="mt-4 btn silo-btn silo-btn__blue text-center"
                            >
                              <strong>SELECT</strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6} lg={6} sm={12} className="box mb-3 cursor-pointer">
                  <Form.Group
                    className={`mb-3 card h-100 ${
                      isCoverageDeclined ? 'selected' : ''
                    }`}
                    onClick={() => setIsCoverageDeclined(true)}
                  >
                    <div className="d-flex justify-content-end">
                      <Form.Check
                        type="radio"
                        name="coverageDeclined"
                        value="coverageDeclined"
                        checked={isCoverageDeclined}
                        readOnly
                      />
                    </div>
                    <span className="plan-details">
                      <span className="text-center mb-2">
                        <ImCross color="red" size={30} />
                      </span>

                      <span className="plan-type text-center">
                        Decline Coverage
                      </span>
                      <p className="text-center fs-6 py-3">
                        I do not wish to take this coverage.
                      </p>
                    </span>
                  </Form.Group>
                </Col>
              </React.Fragment>
            ))}
          </Row>
          {(availibilityMsg && availibilityMsg.length) < 1 && (
            <div className="alert alert-warning" role="alert">
              <span className="d-flex flex-direction-C">
                <div className="d-flex align-items-center">
                  <BsFillInfoCircleFill />
                  <strong className="px-2">Note:</strong>
                </div>
                <span>
                  We are not providing this service in the following states: New
                  York, Indiana.
                </span>
              </span>
            </div>
          )}

          {(availibilityMsg && availibilityMsg.length) > 1 && (
            <div className="alert alert-danger" role="alert">
              <span className="d-flex flex-direction-C">
                <div className="d-flex align-items-center">
                  <BsFillInfoCircleFill />
                  <strong className="px-2">Note:</strong>
                </div>
                <span>{availibilityMsg}</span>
              </span>
            </div>
          )}
          <span className="navigation_bottom">
            <div className="d-flex justify-content-between flex-direction-C">
              <Button
                className="btn w-100-sm silo-btn-small silo-btn__white my-3 mt-md-5"
                onClick={handleBack}
              >
                Back
              </Button>
              <div className="d-flex justify-content-end flex-direction-C">
                {(availibilityMsg && availibilityMsg.length) < 1 &&
                pdPremium?.pd_premium !== 0 ? (
                  <>
                    <ScrollToTopLink>
                      <Button
                        className="btn w-100-sm silo-btn-small silo-btn__blue my-2 mt-0 mt-md-5"
                        onClick={() => handlePDSave(false)}
                      >
                        {buttonLoading ? (
                          <Spinner size="sm" />
                        ) : !isCoverageDeclined ? (
                          <>Save & Next Coverage</>
                        ) : (
                          <>I do not want this coverage</>
                        )}
                      </Button>
                    </ScrollToTopLink>
                  </>
                ) : (
                  <ScrollToTopLink>
                    <Button
                      className="btn w-100-sm silo-btn-small silo-btn__blue my-2 mt-0 mt-md-5"
                      onClick={() => handleTabChange('cargo')}
                    >
                      Move to Next Coverage
                    </Button>
                  </ScrollToTopLink>
                )}
              </div>
            </div>
            {(availibilityMsg && availibilityMsg.length) < 1 &&
            pdPremium?.pd_premium !== 0 &&
            !isCoverageDeclined ? (
              <div>
                <span
                  className="text-primary fw-bold cursor-pointer"
                  onClick={() => handlePDSave(true)}
                >
                  <u>Save & Proceed to Checkout</u>
                </span>
              </div>
            ) : (
              <></>
            )}
          </span>
        </Form>
      </div>
    </>
  );
};

export default PhysicalDamage;
